"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogSaga = createLogSaga;
exports.createLogSagaWithFn = createLogSagaWithFn;
const effects_1 = require("redux-saga/effects");
const amplitude_1 = require("../amplitude/index.js");
function createLogSaga(event, transformer) {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function* logSaga(action) {
        let eventData = { id: event };
        if (transformer) {
            eventData = Object.assign({ data: transformer(action) }, eventData);
        }
        yield (0, effects_1.put)(amplitude_1.amplitudeActions.requestAmplitudeEvent(eventData));
    };
}
function createLogSagaWithFn(eventFn) {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function* logSaga(action) {
        const eventData = eventFn(action);
        if (!eventData) {
            return;
        }
        yield (0, effects_1.put)(amplitude_1.amplitudeActions.requestAmplitudeEvent(eventData));
    };
}
//# sourceMappingURL=createLogSaga.js.map